import { render } from "./Activity_add.vue?vue&type=template&id=4150ece9"
import script from "./Activity_add.vue?vue&type=script&lang=js"
export * from "./Activity_add.vue?vue&type=script&lang=js"
script.render = render

export default script